module.exports = __webpack_public_path__ + "img/close-x.9f946337.svg";